import { RouteTableColumn, RouteTableAction } from '../route-function-report/route-analysis-report/route-analysis-report.models';

export const JOURNAL_COLUMNS: RouteTableColumn[] = [
  { field: 'strComment', title: 'شرح تخلف' },
  { field: 'strTime', title: 'زمان' },
  { field: 'strDate', title: 'تاریخ' },
];
export const DEVICE_EVENT_COLUMNS: RouteTableColumn[] = [
  { field: 'strDate', title: 'تاریخ', sortable: true },
  { field: 'strTime', title: 'ساعت' },
  { field: 'strDeviceStatus_strComment', title: 'وضعیت' },
  { field: 'strDeviceEventsType_strComment', title: 'واقعه' },
];
export const JOURNAL_EXPORT_COLUMNS: RouteTableColumn[] = [
  ...JOURNAL_COLUMNS, { field: 'strFullName', title: 'نام راننده' },
  { field: 'fLat', title: 'عرض جغرافیایی', numeric: true }, { field: 'fLon', title: 'طول جغرافیایی', numeric: true },
];
export const DEVICE_EVENT_EXPORT_COLUMNS: RouteTableColumn[] = [
  { field: 'fLat', title: 'عرض جغرافیایی', numeric: true }, { field: 'fLon', title: 'طول جغرافیایی', numeric: true },
  ...DEVICE_EVENT_COLUMNS,
  { field: 'strFullName', title: 'نام راننده' }, { field: 'strVehicleNo', title: 'پلاک وسیله' },
  { field: 'strMobileType_strComment', title: 'نوع وسیله' }, { field: 'strGPSType_strComment', title: 'نام وسیله' },
  { field: 'strMobileGroup_strComment', title: 'گروه' }, { field: 'strMobileDomain_strComment', title: 'حوزه خدمت' },
  { field: 'strComment', title: 'توضیحات' },
];
export const DEVICE_EVENT_STATUSES = ['متصل', 'خاموش', 'قطع', 'حرکت', 'متوقف', 'واقعه'];
export const DEVICE_INPUT_COLUMNS: RouteTableColumn[] = [
  { field: 'strDate', title: 'تاریخ' }, { field: 'strTime', title: 'ساعت' },
  { field: 'strIOUsage_strComment', title: 'کاربری ورودی' },
  { field: 'strValueTitle', title: 'وضعیت' }, { field: 'strValue', title: 'مقدار' },
];
export const DEVICE_INPUT_EXPORT_COLUMNS: RouteTableColumn[] = [
  { field: 'fLat', title: 'عرض جغرافیایی', numeric: true }, { field: 'fLon', title: 'طول جغرافیایی', numeric: true },
  ...DEVICE_INPUT_COLUMNS, { field: 'strFullName', title: 'نام راننده' },
  { field: 'strMobileDomain_strComment', title: 'حوزه خدمت' }, { field: 'strMobileType_strComment', title: 'گروه' },
  { field: 'strVehicleNo', title: 'پلاک' },
];
export const DEVICE_EVENT_ACTIONS: RouteTableAction[] = [{ kind: 'map', title: 'نمایش موقعیت روی نقشه', icon: 'fa-map-marker' }];
